<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-card-title class="primary">
          <span style="color: #fff" class="text-h5">Exportar Aula Polivalência</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <ValidationObserver v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(enableSubmit)">
                <v-row>
                  <v-col class="pt-4 pb-0" cols="12">
                    <ValidationProvider name="Turma" rules="required" v-slot="{ errors }">
                      <e-label class="font-weight-medium">Turma</e-label>
                      <p class="font-weight-regular">
                        <v-select
                          :items="turmas"
                          item-text="turma.descricao"
                          item-value="turma.id"
                          :hint="`${turmaSelecionada?.turma?.franquia?.descricao || ''}`"
                          return-object
                          label="Selecione o campo abaixo"
                          v-model="turmaSelecionada"
                          :error-messages="errors"
                        ></v-select>
                      </p>
                    </ValidationProvider>
                  </v-col>

                  <v-col class="pt-4 pb-0" cols="12">
                    <e-label class="font-weight-medium">Tipo de Aula</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.tipo_de_aula }}
                    </p>
                  </v-col>

                  <v-col class="pt-0 pb-0" :cols="12" :sm="4">
                    <ValidationProvider name="Data" rules="required" v-slot="{ errors }">
                      <v-dialog
                        ref="dateDialog"
                        v-model="modal"
                        :return-value.sync="dataAulaDuplicada"
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <e-label>Selecione uma data</e-label>
                          <v-text-field
                            dense
                            solo
                            v-model="data_aula"
                            label="Data"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :error-messages="errors"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          color="primary"
                          v-model="dataAulaDuplicada"
                          scrollable
                          :allowed-dates="allowedDates"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="modal = false">Cancelar</v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.dateDialog.save(dataAulaDuplicada)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <div class="mt-4 mb-2">
                  <e-label class="font-weight-medium">Horários</e-label>
                </div>
                <v-row dense>
                  <v-col
                    v-for="(conteudo, index) in JSON.parse(gestaoDeAula.conteudo_polivalencia)"
                    :key="index"
                    cols="12"
                    md="6"
                  >
                    <v-card outlined class="pa-3 rounded-lg">
                      <h3 class="text-primary mb-2">
                        {{ gestaoDeAula.disciplinas_com_descricao[index]?.descricao }} -
                      </h3>
                    </v-card>
                    <div outlined class="pa-3 rounded-lg">
                      <e-label>Selecione um horário</e-label>
                      <e-autocomplete
                        :items="getHorariosDisponiveis(index)"
                        clearable
                        outlined
                        chips
                        small-chips
                        label="Selecione os horários"
                        item-text="descricao"
                        item-value="id"
                        v-model="horarios_selecionados_extras[index]"
                        dense
                      />
                    </div>
                  </v-col>
                  <v-col cols="12" class="mt-4">
                    <e-label class="font-weight-medium">Metodologia</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.metodologia }}
                    </p>
                  </v-col>
                </v-row>

                <v-divider class="my-6"></v-divider>
                <e-progresso-preenchimento
                  :expectedItems="itemsEsperados"
                  :filledItems="itemsPreenchidos"
                  @total-filled-changed="
                    (value) => $checkTotallyFilled(value, 'totalmentePreenchido')
                  "
                />

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    style="color: #fff"
                    class="red darken-1"
                    @click="$emit('dialogChange', false)"
                  >
                    Fechar
                  </v-btn>
                  <v-btn
                    style="color: #fff"
                    class="green darken-1"
                    type="submit"
                    :disabled="!totalmentePreenchido"
                  >
                    Salvar
                  </v-btn>
                </v-card-actions>
              </form>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="exportarAula"
    >
    </e-modal-confirm>
  </v-row>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    submittingForm: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      gestoesFiltradas: [],
      dataAulaDuplicada: null,
      modal: false,
      menu: false,
      gestaoDeAula: {},
      data_aula: null,
      confirmDialog: false,
      turmas: [],
      turmaSelecionada: {
        turma: {
          id: null,
          franquia: {
            descricao: "",
            fantasia: "",
          },
        },
      },
      objectModal: {
        title: "Exportar aula",
        message: "Tem certeza que deseja exportar esta aula?",
      },

      horarios: [],
      date: null,
      // horarioSelecionado: null,
      horariosFiltrados: [],
      horarioSelecionado: {
        descricao: "Escolha um horario",
      },
      horarios_selecionados_extras: [],
      itemsEsperados: [
        { label: "Turma", value: "turmaSelecionada" },
        { label: "Data", value: "dataAulaDuplicada" },
      ],
      itemsPreenchidos: [],
      totalmentePreenchido: false,
    };
  },
  created() {
    this.$watch("turmaSelecionada", (val) => {
      const shouldAdd = !!(val && val.turma && val.turma.id);
      this.$toggleItemPreenchidoBarraProgresso(
        "turmaSelecionada",
        shouldAdd,
        this.itemsPreenchidos
      );
    });

    this.$watch("dataAulaDuplicada", (val) => {
      this.$toggleItemPreenchidoBarraProgresso("dataAulaDuplicada", !!val, this.itemsPreenchidos);
    });

    this.$watch(
      "form",
      (val) => {
        if (val && val.disciplinas_com_descricao && val.disciplinas_com_descricao.length > 0) {
          this.itemsEsperados = this.itemsEsperados.filter(
            (item) => !item.value.startsWith("horarios_selecionados_extras")
          );

          val.disciplinas_com_descricao.forEach((disc, index) => {
            const horarioItem = {
              label: `Horário - ${disc.descricao}`,
              value: `horarios_selecionados_extras[${index}]`,
              index,
            };

            this.itemsEsperados.push(horarioItem);

            this.$watch(`horarios_selecionados_extras.${index}`, (val) => {
              this.$toggleItemPreenchidoBarraProgresso(
                horarioItem.value,
                !!val,
                this.itemsPreenchidos
              );
            });
          });
        }
      },
      { immediate: true }
    );
  },
  watch: {
    form: {
      immediate: true,
      handler(val) {
        this.gestaoDeAula = val;
      },
    },
    turmaSelecionada: {
      immediate: true,
      handler(val) {
        this.horarios = val.turma.horarios;
      },
    },
    dialog: {
      async handler(val) {
        if (val) {
          this.$loaderService.open("Carregando gestões de aula");
          try {
            const gestoes = await this.$services.gestoesDeAulasService.listarGestoesProfessor(
              this.gestaoDeAula
            );

            this.gestoesFiltradas = gestoes.filter(
              (gestao) => gestao.turma_id !== this.gestaoDeAula.turma_id
            );

            this.turmas = this.gestoesFiltradas;
          } catch (error) {
            this.$handleError(error);
          } finally {
            this.$loaderService.close();
          }
        }
      },
    },
    dataAulaDuplicada(value) {
      const date = new Date(value);
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(date);
      this.data_aula = data_old.replaceAll("/", "/");
      const diaDaSemana = date.getDay(); // 0 = domingo, 1 = segunda, ..., 6 = sábado
      this.filtrarHorariosPorDiaDaSemana(diaDaSemana);
    },
  },
  computed: {
    horariosTotalmenteSelecionados() {
      return (
        JSON.parse(this.gestaoDeAula.conteudo_polivalencia).length <=
        this.horarios_selecionados_extras.flat().filter((v) => v !== null).length
      );
    },
  },
  methods: {
    allowedDates(date) {
      if (!this.turmaSelecionada || !this.turmaSelecionada.relacoesDiasHorarios) {
        return false;
      }

      const dayOfWeek = new Date(date).getDay();

      const diasPermitidos = this.turmaSelecionada.relacoesDiasHorarios.map((rel) => rel.dia.id);

      return diasPermitidos.includes(dayOfWeek);
    },
    async filtrarHorariosPorDiaDaSemana(diaDaSemana) {
      try {
        if (!this.turmaSelecionada?.relacoesDiasHorarios) {
          this.horariosFiltrados = [];
          return;
        }

        let horariosDoDia = [];

        if (diaDaSemana === 5) {
          horariosDoDia = this.turmaSelecionada.relacoesDiasHorarios.map(
            (relacao) => relacao.horario
          );
        } else {
          horariosDoDia = this.turmaSelecionada.relacoesDiasHorarios
            .filter((relacao) => relacao.dia.id === diaDaSemana)
            .map((relacao) => relacao.horario);
        }

        this.horariosFiltrados = horariosDoDia;
      } catch (error) {
        this.horariosFiltrados = [];
      }
    },
    enableSubmit() {
      if (!this.turmaSelecionada.turma.id) {
        this.$toast.danger("Por favor, selecione uma turma");
        return;
      }

      if (!this.dataAulaDuplicada) {
        this.$toast.danger("Por favor, selecione uma data");
        return;
      }

      if (
        this.gestaoDeAula.tipo_de_aula !== "Aula Remota" &&
        !this.horariosTotalmenteSelecionados
      ) {
        this.$toast.danger("Por favor, selecione um horário para cada componente curricular");
        return;
      }

      this.confirmDialog = !this.confirmDialog;
      this.gestaoDeAula.data = this.dataAulaDuplicada;
    },
    async exportarAula() {
      this.$loaderService.open("Exportando a Aula");
      try {
        this.gestaoDeAula.horarios_extras = await this.getHorariosExtras();

        this.gestaoDeAula.instrutorDisciplinaTurma_id = parseInt(this.turmaSelecionada.id, 10);
        this.gestaoDeAula.turma_id = this.turmaSelecionada.turma.id;
        this.confirmDialog = !this.confirmDialog;

        this.$emit("dialogChange", false);
        await this.$services.aulasService.criar(this.gestaoDeAula);

        this.$toast.success("Aula exportada com sucesso!");
        this.$router.push({ name: "aulas" });
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async getHorariosExtras() {
      const disciplinas = this.turmaSelecionada.disciplinas;
      const horarios_selecionados_extras = this.horarios_selecionados_extras || [];

      const horariosMapeados = disciplinas.map((disc, idx) => {
        const itens = horarios_selecionados_extras[idx] || [];

        const arrayItens = Array.isArray(itens) ? itens : [itens];
        const array = [].concat(...arrayItens).filter((v) => v !== undefined && v !== null);

        return { id: disc.id, array };
      });

      return JSON.stringify(horariosMapeados);
    },
    getHorariosDisponiveis(index) {
      const all = (this.horarios_selecionados_extras || [])
        .filter((v) => v != null)
        .map((v) => Number(v.id ?? v));

      const hereVal = this.horarios_selecionados_extras[index];
      const here = hereVal ? [Number(hereVal.id ?? hereVal)] : [];
      const elsewhere = all.filter((id) => !here.includes(id));

      return this.horariosFiltrados.filter((h) => !elsewhere.includes(Number(h.id)));
    },
  },
};
</script>
